import { useState, useLayoutEffect } from 'react'
import debounce from 'lodash.debounce'

export interface ScreenSize {
  width: number
  height: number
}

export default function useWindowSize(delay = 100, N = 0) {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useLayoutEffect(() => {
    let previousWidth = window.innerWidth
    let previousHeight = window.innerHeight

    const handleResize = debounce(() => {
      const newWidth = window.innerWidth
      const newHeight = window.innerHeight

      if (Math.abs(newWidth - previousWidth) > N || Math.abs(newHeight - previousHeight) > N) {
        setScreenSize({
          width: newWidth,
          height: newHeight,
        })

        previousWidth = newWidth
        previousHeight = newHeight
      }
    }, delay)

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      handleResize.cancel()
    }
  }, [delay, N])

  return { screenSize }
}
